import Iconify from '../../../components/Iconify';
// components
import Label from '../../../components/Label';
import SvgIconStyle from '../../../components/SvgIconStyle';
// routes
import { PATH_DASHBOARD } from '../../../routes/paths';

// ----------------------------------------------------------------------

const getIcon = (name) => <SvgIconStyle src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const ICONS = {
  blog: getIcon('ic_blog'),
  cart: getIcon('ic_cart'),
  chat: getIcon('ic_chat'),
  mail: getIcon('ic_mail'),
  user: getIcon('ic_user'),
  kanban: getIcon('ic_kanban'),
  banking: getIcon('ic_banking'),
  booking: getIcon('ic_booking'),
  invoice: getIcon('ic_invoice'),
  calendar: getIcon('ic_calendar'),
  ecommerce: getIcon('ic_ecommerce'),
  analytics: getIcon('ic_analytics'),
  dashboard: getIcon('ic_dashboard'),
  menuItem: getIcon('ic_menu_item')
};

const navConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    subheader: 'dashboard',
    items: [
      { title: 'overview', path: PATH_DASHBOARD.project.overview, icon: ICONS.dashboard },
      {
        title: 'Insights',
        path: PATH_DASHBOARD.project.insights,
        icon: ICONS.analytics,
        children: [
          { title: 'signals', path: PATH_DASHBOARD.project.signals },
          { title: 'anomalies', path: PATH_DASHBOARD.project.anomalies },
          { title: 'identities', path: PATH_DASHBOARD.project.identities }
        ]
      },
      {
        title: 'Setup',
        path: PATH_DASHBOARD.project.setup,
        icon: ICONS.kanban,
        children: [
          { title: 'API Keys', path: PATH_DASHBOARD.project.apiKeys },
          { title: 'SDK', path: PATH_DASHBOARD.project.sdk },
          { title: 'integrations', path: PATH_DASHBOARD.project.integrations },
          { title: 'routing', path: PATH_DASHBOARD.project.routing }
        ]
      }
    ]
  },

  // MANAGEMENT
  // ----------------------------------------------------------------------
  {
    subheader: 'manage',
    items: [
      { title: 'team', path: PATH_DASHBOARD.manage.users, icon: ICONS.user },
      { title: 'billing', path: PATH_DASHBOARD.manage.billing, icon: ICONS.invoice }
    ]
  }
];

export default navConfig;
